export enum ModalTitle {
  SFTP_DOC_MODAL = "Status Check",
  TEXT_NOTE_DOC = "Text Note",
  LETTER_UPLOAD_DOC = "Letter Upload",
  NYCBS_EXTERNAL_LOGS_MODAL = "Logs",
}
